import React from "react";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FuelPlanGuidance = () => (
  <aside
    aria-labelledby="fuel-plan-guidance-title"
    className="fuel-plan-guidance"
    role="note"
  >
    <FontAwesomeIcon
      aria-hidden="true"
      className="fuel-plan-guidance-icon"
      icon={faInfoCircle}
    />
    <div>
      <h2 id="fuel-plan-guidance-title">Fuel plan guidance</h2>
      <p>
        Fuel recommendations do not account for hours of service, load weight,
        weather, terrain, or road conditions. Use your best judgment and adjust
        as conditions require.
      </p>
    </div>
  </aside>
);

export default FuelPlanGuidance;
